export default __webpack_public_path__ + "static/media/s4_title20cbutton.ef93b91b.png";